export default {
  items: [
    // {
    //   icon: "tachometer-alt",
    //   link: "/",
    //   permissions: [],
    //   resource: "",
    //   text: "Home"
    // },
    {
      icon: "images",
      link: "/views?sort=latestImageUpload,desc",
      permissions: ["read:views"],
      resource: "views",
      text: "Views"
    },
    {
      icon: "hand-holding-usd",
      link: "/clients?sort=name,asc",
      permissions: ["read:clients"],
      resource: "clients",
      text: "Clients"
    },
    {
      icon: "camera",
      link: "/cameras?sort=voltage",
      permissions: ["read:cameras", "read:systems"],
      resource: "cameras",
      text: "Systems"
    },
    {
      icon: "film",
      link: "/sequences?sort=name,asc",
      permissions: ["read:sequences"],
      resource: "sequences",
      text: "Sequences"
    },
    {
      icon: "video",
      link: "/streams?sort=name,asc",
      permissions: ["read:videos"],
      resource: "streams",
      text: "Streams"
    },
    {
       icon: "map",
       link: "/maps?sort=name,asc",
       permissions: ["read:maps"],
       resource: "maps",
       text: "Maps"
     },
     {
        icon: "handshake",
        link: "/partners?sort=name,asc",
        permissions: ["read:partners"],
        resource: "partners",
        text: "Partners"
      },
      {
         icon: "project-diagram",
         link: "/projects?sort=name,asc",
         permissions: ["read:projects"],
         resource: "projects",
         text: "Projects"
       },
      {
         icon: "users",
         link: "/users?sort=name,asc",
         permissions: ["read:users"],
         resource: "users",
         text: "Users"
       },
  ]
}
